import React, {Component} from 'react'
import { connect } from 'react-redux'
import EnquiryActionCreators from 'redux-modules/enquiry/EnquiryActionCreators'
import { Form, Field } from 'react-final-form'
import {Helmet} from 'react-helmet'
import Footer from 'components/footer/Footer'

const required = value => (value ? undefined : 'Required')

const InputField =({ input, meta ,...rest}) => (
    <div style={{fontSize: '0.8rem'}}>
        <label>{rest.label}</label>
        <input className='form-control mb-3' {...input} type="text" placeholder={rest.placeholder} />
        {meta.error && meta.touched && <span style={{color: '#ff3fc5'}}>{meta.error}</span>}
    </div>
)

const TextAreaField =({ input, meta ,...rest}) => (
    <div style={{fontSize: '0.8rem'}}>
        <label>{rest.label}</label>
        <textarea className='form-control mb-3' style={{height: '160px'}} {...input} type="text" placeholder={rest.placeholder} />
        {meta.error && meta.touched && <span style={{color: '#ff3fc5'}}>{meta.error}</span>}
    </div>
)

class EnquiryForm  extends Component {

      constructor(props) {
          super(props)
          this.state = {
            enquirySubmitted: false
          };
      }


    onSubmit=(values) =>{
       console.log("values", values)
        return this.props.postEnquiry('enquiry1',{
            "subject":"Enquiry Form Owlgo",
            "data":values
        })
        // return Promise.resolve(values)
    }

    render () {
        return (
            <div>
                <Helmet>
                    <title>Schedule a Demo &#8212; OwlGo</title>
                </Helmet>
                <div className='container mt-4 mb-5' style={{paddingTop: '100px'}}>
                    <div className='row'>
                        <div className='col-lg-6 d-flex justify-content-center mb-5'>
                            <div className='enquiry--form mb-5'>
                                <h1 className='mt-4 mb-5 enquiry--h1' style={{fontWeight: 700}}>SCHEDULE A DEMO</h1>
                                <Form
                                    onSubmit={this.onSubmit}

                                    render={({ handleSubmit, pristine, invalid, reset }) => (
                                        <form onSubmit={
                                            event => {
                                                const promise = handleSubmit(event);
                                                promise.then(() => {
                                                    reset()
                                                    this.setState({enquirySubmitted: true})
                                                });
                                                return promise;
                                                }
                                            } style={{margin: 'auto'}}>
                                            <div className='mb-4'>
                                                <Field  name="name" component={InputField} label={"Name"} validate={required} />
                                            </div>
                                            <div className='mb-4'>
                                                <Field  name="email" component={InputField} label={"Email"} validate={required} />
                                            </div>
                                            <div className='mb-4'>
                                                <Field  name="contactNumber" component={InputField} label={"Contact Number"} validate={required} />
                                            </div>
                                            <div className='mb-4'>
                                                <Field  name="company" component={InputField} label={"Company"} validate={required} />
                                            </div>
                                            <div className='mb-4'>
                                                <Field  name="message" component={TextAreaField} label={"Message"} validate={required} />
                                            </div>

                                            <button className='btn btn-primary d-flex align-items-center mb-4' type="submit" disabled={ pristine || invalid}>
                                                <span className='pr-5'>Submit</span> 
                                                <img alt='' src='img/button-arrow.svg' style={{width: '10.4px', height: '12px'}} />
                                            </button>
                                            {
                                                this.state.enquirySubmitted ? <div style={{letterSpacing: '0.1rem', color: '#33aa49'}}>Your enquiry has been submitted!</div> : null
                                            }
                                            
                                        </form>
                                    )}
                                />
                            </div>
                        </div>
                        <div className='col-lg-6 d-flex justify-content-center enquiry--line mb-5'>
                            <div className='enquiry--contact'>
                                <h1 className='mt-4 mb-5 enquiry--h1' style={{fontWeight: 700}}>CONTACT</h1>
                                <div className='mb-4' style={{fontSize: '0.8rem'}}>Contact us today to find out what OwlGo can do for your event organizing needs.</div>
                                <div style={{fontSize: '0.8rem'}} className='mb-4'>
                                    <div style={{fontWeight: 700, color: '#404041'}}>SINGAPORE OFFICE</div>
                                    <div>12 Arumugam Road, </div>
                                    <div>LTC Building B #01-01, </div>
                                    <div>Singapore 409958</div>
                                </div>
                                <div style={{fontSize: '0.8rem', color: '#404041'}} className='mb-5'><span style={{fontWeight: '700', textTransform: 'uppercase'}}>Email</span>: hello@owlgo.co</div>
                                <iframe height="400" frameBorder="0" style={{border: 0, width: '100%'}}
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1994.3749228046136!2d103.8908285!3d1.3260286!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da181ff4778475%3A0xc346ed7312ad6849!2sTCG+Co-working+Space!5e0!3m2!1sen!2ssg!4v1548663595520" allowFullScreen></iframe> 
                            </div>
                            
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}



const mapStateToProps = ( state, props ) => ({

})

const mapDispatchToProps ={
    postEnquiry: EnquiryActionCreators.postEnquiry
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EnquiryForm)




// WEBPACK FOOTER //
// ./src/croutes/enquiry/index.js